// Chiessa Institute - i18n dictionary (ES / EN)
export const TRANSLATIONS = {
  es: {
    nav: {
      home: "Inicio",
      about: "Quiénes somos",
      gadgets: "PsicoGadgets",
      enter: "Entrar a la plataforma",
      login: "Iniciar sesión",
      register: "Crear cuenta",
      logout: "Cerrar sesión",
    },
    site: {
      hero_eyebrow: "Chiessa Institute",
      hero_title: "Investigación aplicada y tecnología para la neuroeducación inclusiva",
      hero_lead: "Formamos a quienes rodean al niño, acompañamos a cada familia y generamos evidencia para que la inclusión deje de ser un buen deseo y se vuelva una práctica diaria.",
      hero_cta: "Entrar a la plataforma",
      hero_cta2: "Conocer los módulos",
      pillars_eyebrow: "Sobre qué se sostiene",
      pillars_title: "Dos pilares que se alimentan entre sí",
      pillar1_title: "Investigación aplicada",
      pillar1_desc: "Cada recurso nace de evidencia y vuelve a ella. La primera base de conocimiento propia sobre neurodivergencia y aula en la región.",
      pillar2_title: "Tecnología frontera",
      pillar2_desc: "Sistemas que aprenden y se adaptan a cada niño, cada docente y cada contexto. Nunca genéricos. La decisión es siempre humana.",
      mods_eyebrow: "Una plataforma, cinco módulos",
      mods_title: "Para cada actor de la educación inclusiva",
      why_eyebrow: "Por qué Chiessa Institute",
      why_title: "Lo que nadie más puede ofrecer",
      why1_title: "Evidencia propia",
      why1_desc: "Cada uso genera datos que mejoran los recursos. Un activo que crece solo y no se copia.",
      why2_title: "Especialistas",
      why2_desc: "No somos generalistas. Toda la plataforma gira alrededor de la inclusión y el neurodesarrollo.",
      why3_title: "De Honduras a la región",
      why3_desc: "Pensado para el contexto hondureño y su ley, diseñado para crecer en Centroamérica.",
      cta_eyebrow: "Trabajemos juntos",
      cta_title: "Lleva la neuroeducación inclusiva a tu institución",
      cta_desc: "Escuelas, docentes, psicólogos y familias. Conversemos sobre cómo el instituto puede acompañarte.",
      cta_btn: "Escríbenos a info@chiessainstitute.com",
      explore_module: "Conocer el módulo",
    },
    modules: {
      circulo: { name: "Círculo", who: "Familias", desc: "Acompañamiento individualizado, bitácora, parte del día y reportes." },
      aula: { name: "Aula", who: "Docentes", desc: "Formación práctica y certificada en neurodivergencia." },
      sintonia: { name: "Sintonía", who: "Psicólogos", desc: "Medición de resultados y supervisión que te hace crecer." },
      brujula: { name: "Brújula", who: "Escuelas", desc: "Objetivos estratégicos, planes y cumplimiento de inclusión." },
      sello: { name: "Sello Sombra", who: "Maestra sombra", desc: "La primera certificación con respaldo teórico-científico para maestras acompañantes en el aula." },
      observatorio: { name: "Observatorio", who: "Investigación", desc: "Datos y estudios que solo este instituto puede producir." },
    },
    about: {
      mission_eye: "Misión",
      mission_title: "Para qué existimos",
      mission_big: "Que ningún niño quede fuera de la educación por la forma en que aprende.",
      mission_body: "Formamos a quienes lo rodean, acompañamos a cada familia y generamos evidencia para que la inclusión deje de ser un buen deseo y se vuelva una práctica diaria, medible y al alcance de cualquier escuela.",
      vision_eye: "Visión",
      vision_title: "A dónde vamos",
      vision_big: "Ser el referente de la neuroeducación inclusiva en Centroamérica.",
      vision_body: "El lugar donde la investigación aplicada y la tecnología que aprende se ponen, todos los días, al servicio de cada niño, cada docente, cada psicólogo y cada familia.",
      values_eye: "Valores",
      values_title: "En qué creemos",
      values: [
        { t: "La decisión es humana", d: "La tecnología apoya, nunca reemplaza el criterio del docente ni del profesional. La última palabra siempre es de una persona." },
        { t: "Evidencia antes que opinión", d: "Lo que hacemos nace de datos y vuelve a ellos. Medimos para mejorar, no para impresionar." },
        { t: "Inclusión sin excepciones", d: "Cada mente que aprende distinto tiene lugar. La neurodivergencia es una forma de ser que acompañamos." },
        { t: "Cerca de las familias", d: "El niño y su entorno están en el centro de todo. Nadie conoce mejor a su hijo que sus padres." },
        { t: "Rigor con calidez", d: "Somos serios con la ciencia y cálidos con las personas. Lo técnico nunca está por encima de lo humano." },
        { t: "La privacidad es un principio", d: "Los datos de un niño le pertenecen a su familia. Cuidamos cada expediente como lo íntimo que es." },
      ],
      quote_eye: "Trabajemos juntos",
      quote: "«La inclusión deja de ser un deseo cuando alguien la hace posible»",
      quote_by: "Dra. Mariela Chiessa",
      quote_desc: "Si compartes la convicción de que cada mente merece aprender, conversemos.",
    },
    gadgets: {
      eye: "PsicoGadgets",
      title: "Herramientas gratuitas para orientarte",
      lead: "Tests rápidos y calculadoras de neuroeducación. Son una orientación, no un diagnóstico. Úsalas, compártelas, y si algo te preocupa, conversemos.",
      free: "Probar gratis",
      restart: "Reiniciar",
      finish: "Ver resultado",
      cross: "Los PsicoGadgets están hechos con la tecnología de DataGadgets, de Dataísmo AI Technologies.",
      cross_btn: "Conoce los DataGadgets",
      band: { baja: "Nivel bajo", media: "Nivel medio", alta: "Nivel alto" },
    },
    auth: {
      login_title: "Entra a la plataforma",
      login_lead: "Cada rol ve solo lo que le corresponde. Ingresa con tu correo o crea tu cuenta seleccionando tu rol.",
      email: "Correo electrónico",
      password: "Contraseña",
      name: "Nombre completo",
      role: "Rol",
      submit_login: "Entrar",
      submit_register: "Crear cuenta",
      no_account: "¿No tienes cuenta?",
      have_account: "¿Ya tienes cuenta?",
      register_here: "Crear cuenta",
      login_here: "Iniciar sesión",
      back: "Volver al sitio web",
      demo_hint: "",
    },
    roles: {
      familia: "Familia",
      docente: "Docente",
      sombra: "Maestra sombra",
      psicologa: "Psicóloga",
      escuela: "Escuela",
      admin: "Administradora",
    },
    app: {
      welcome: "Bienvenida",
      welcome_m: "Bienvenido",
      home_eye: "Plataforma",
      home_title: "Cinco módulos, un mismo instituto",
      home_lead: "Empezamos por Círculo, el acompañamiento de cada niño.",
      institute_tools: "Herramientas del instituto",
      module_active: "Activo",
      module_soon: "Próximamente",
      only_mariela: "Solo Mariela",
      enter: "Entrar",
      open: "Abrir",
      back: "Volver",
      ai_label: "Sistema Inteligente",
      ai_generating: "Generando con Sistema Inteligente...",
      ai_generated_by: "Generado por Sistema Inteligente",
    },
    dashboard: {
      only_mariela: "Panel de Mariela",
      title: "Control operativo y financiero",
      mrr: "Ingreso mensual",
      users: "Usuarios activos",
      due: "Por cobrar",
      arr: "Proyección anual",
      by_module: "Por módulo",
      simulator: "Simulador de ingresos",
      sim_lead: "Mueve los números y mira el ingreso cambiar en vivo.",
      conservative: "Conservador",
      base: "Base",
      aggressive: "Agresivo",
      growth: "Crecimiento mensual",
      sim_mrr: "ingreso mensual",
      sim_arr: "proyección a 12 meses",
    },
    footer: "Diseñada por Dataísmo AI Technologies",
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      gadgets: "PsicoGadgets",
      enter: "Enter the platform",
      login: "Sign in",
      register: "Create account",
      logout: "Log out",
    },
    site: {
      hero_eyebrow: "Chiessa Institute",
      hero_title: "Applied research and technology for inclusive neuroeducation",
      hero_lead: "We train those around the child, support every family, and generate evidence so inclusion stops being a wish and becomes a daily practice.",
      hero_cta: "Enter the platform",
      hero_cta2: "Explore modules",
      pillars_eyebrow: "What it stands on",
      pillars_title: "Two pillars that feed each other",
      pillar1_title: "Applied research",
      pillar1_desc: "Every resource is born from evidence and returns to it. The first proprietary knowledge base on neurodivergence and the classroom in the region.",
      pillar2_title: "Frontier technology",
      pillar2_desc: "Systems that learn and adapt to each child, teacher and context. Never generic. The decision is always human.",
      mods_eyebrow: "One platform, five modules",
      mods_title: "For everyone in inclusive education",
      why_eyebrow: "Why Chiessa Institute",
      why_title: "What no one else can offer",
      why1_title: "Proprietary evidence",
      why1_desc: "Every use generates data that improves the resources. An asset that grows on its own and cannot be copied.",
      why2_title: "Specialists",
      why2_desc: "We are not generalists. The whole platform revolves around inclusion and neurodevelopment.",
      why3_title: "From Honduras to the region",
      why3_desc: "Built for the Honduran context and its law, designed to grow across Central America.",
      cta_eyebrow: "Let's work together",
      cta_title: "Bring inclusive neuroeducation to your institution",
      cta_desc: "Schools, teachers, psychologists and families. Let's talk about how the institute can support you.",
      cta_btn: "Write to us at info@chiessainstitute.com",
      explore_module: "Explore the module",
    },
    modules: {
      circulo: { name: "Círculo", who: "Families", desc: "Individualized support, log, daily note and reports." },
      aula: { name: "Aula", who: "Teachers", desc: "Practical, certified training in neurodivergence." },
      sintonia: { name: "Sintonía", who: "Psychologists", desc: "Outcome measurement and supervision that helps you grow." },
      brujula: { name: "Brújula", who: "Schools", desc: "Strategic goals, plans and inclusion compliance." },
      sello: { name: "Sello Sombra", who: "Shadow teacher", desc: "The first serious certification for classroom aides." },
      observatorio: { name: "Observatory", who: "Research", desc: "Data and studies only this institute can produce." },
    },
    about: {
      mission_eye: "Mission",
      mission_title: "Why we exist",
      mission_big: "That no child is left out of education because of the way they learn.",
      mission_body: "We train those around them, support every family, and generate evidence so inclusion becomes a daily, measurable practice.",
      vision_eye: "Vision",
      vision_title: "Where we are going",
      vision_big: "To be the reference for inclusive neuroeducation in Central America.",
      vision_body: "The place where applied research and learning technology serve every child, teacher, psychologist and family.",
      values_eye: "Values",
      values_title: "What we believe",
      values: [
        { t: "The decision is human", d: "Technology supports, it never replaces the judgment of the teacher or the professional. The final word is always a person's." },
        { t: "Evidence before opinion", d: "What we do is born from data and returns to it. We measure to improve, not to impress." },
        { t: "Inclusion without exceptions", d: "Every mind that learns differently has a place." },
        { t: "Close to families", d: "The child and their environment are at the center of everything. No one knows a child better than their parents." },
        { t: "Rigor with warmth", d: "We are serious about science and warm with people." },
        { t: "Privacy is a principle", d: "A child's data belongs to their family. We protect every record as the private thing it is." },
      ],
      quote_eye: "Let's work together",
      quote: "«Inclusion stops being a wish when someone makes it possible»",
      quote_by: "Dra. Mariela Chiessa",
      quote_desc: "If you share the conviction that every mind deserves to learn, let's talk.",
    },
    gadgets: {
      eye: "PsicoGadgets",
      title: "Free tools to orient you",
      lead: "Quick tests and calculators. Orientation, not diagnosis. Use them, share them, and if something worries you, let's talk.",
      free: "Try free",
      restart: "Restart",
      finish: "See result",
      cross: "PsicoGadgets are built with DataGadgets technology, by Dataísmo AI Technologies.",
      cross_btn: "Meet the DataGadgets",
      band: { baja: "Low level", media: "Medium level", alta: "High level" },
    },
    auth: {
      login_title: "Enter the platform",
      login_lead: "Each role only sees what belongs to them. Sign in or create your account by selecting your role.",
      email: "Email",
      password: "Password",
      name: "Full name",
      role: "Role",
      submit_login: "Sign in",
      submit_register: "Create account",
      no_account: "Don't have an account?",
      have_account: "Already have an account?",
      register_here: "Create account",
      login_here: "Sign in",
      back: "Back to website",
      demo_hint: "",
    },
    roles: {
      familia: "Family",
      docente: "Teacher",
      sombra: "Shadow teacher",
      psicologa: "Psychologist",
      escuela: "School",
      admin: "Administrator",
    },
    app: {
      welcome: "Welcome",
      welcome_m: "Welcome",
      home_eye: "Platform",
      home_title: "Five modules, one institute",
      home_lead: "We start with Círculo, the support for each child.",
      institute_tools: "Institute tools",
      module_active: "Active",
      module_soon: "Soon",
      only_mariela: "Mariela only",
      enter: "Enter",
      open: "Open",
      back: "Back",
      ai_label: "Smart System",
      ai_generating: "Generating with Smart System...",
      ai_generated_by: "Generated by Smart System",
    },
    dashboard: {
      only_mariela: "Mariela's panel",
      title: "Operational & financial control",
      mrr: "Monthly revenue",
      users: "Active users",
      due: "Due",
      arr: "Annual projection",
      by_module: "By module",
      simulator: "Revenue simulator",
      sim_lead: "Move the numbers and watch revenue change live.",
      conservative: "Conservative",
      base: "Base",
      aggressive: "Aggressive",
      growth: "Monthly growth",
      sim_mrr: "monthly revenue",
      sim_arr: "12-month projection",
    },
    footer: "Designed by Dataísmo AI Technologies",
  },
};
